import React from "react";
import Style from '../../styles/landing/Suporte.module.css'; 
import { FaArrowLeft } from "react-icons/fa";

export default function ArtPlanoNutriComple({ title }) {

  return (
    <div className={Style.containerArt}>     
      <div className={Style.articleHeader}>
        <h2>{title}</h2>
      </div>
      <div className={Style.articleBody}>
        <p>
          O plano nutricional completo é gerado a partir da combinação da sua
          avaliação corporal, objetivos e respostas ao questionário de hábitos.
        </p>
        <ol>
          <li>Realize uma avaliação corporal recente.</li>
          <li>
            Acesse o menu <strong>“Plano nutricional”</strong> e responda ao
            questionário.
          </li>
          <li>Revise suas informações e confirme o envio.</li>
          <li>
            Assim que o plano estiver pronto, você poderá visualizar cardápios,
            orientações diárias e metas de curto e médio prazo.
          </li>
        </ol>
        <p>
          Lembre-se: o plano tem caráter informativo/educativo e não substitui o
          acompanhamento com um profissional habilitado.
        </p>
      </div>
    </div>
  );
}